"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestionHighlightOptimisticResponse = exports.updateQuestionLearningPoint = exports.ADD_QUESTION_LEARNING_POINT = exports.updateQuestionHighlights = exports.ADD_QUESTION_HIGHLIGHT = exports.optimisticQuestionCommentRemove = exports.updateQuestionCommentsRemove = exports.QUESTION_COMMENT_REMOVE = exports.optimisticCommentLike = exports.QUESTION_COMMENT_LIKE = exports.optimisticQuestionComment = exports.updateQuestionComments = exports.QUESTION_COMMENTS = exports.optimisticQuestionLike = exports.QUESTION_LIKE = exports.getQuestionTypeName = exports.getLikeData = void 0;
const client_1 = require("@apollo/client");
const luxon_1 = require("luxon");
const models_1 = require("../../../models");
const fragments_1 = require("../../fragments");
const getLikeData = (like, item) => {
    let { likes = 0, dislikes = 0, isLikedByMe } = item;
    if (isLikedByMe === models_1.EQuestionLike.LIKE) {
        likes = likes - 1;
        if (like === models_1.EQuestionLike.DISLIKE) {
            dislikes = dislikes + 1;
        }
    }
    else if (isLikedByMe === models_1.EQuestionLike.DISLIKE) {
        dislikes = dislikes - 1;
        if (like === models_1.EQuestionLike.LIKE) {
            likes = likes + 1;
        }
    }
    else {
        if (like === models_1.EQuestionLike.LIKE) {
            likes = likes + 1;
        }
        else if (like === models_1.EQuestionLike.DISLIKE) {
            dislikes = dislikes + 1;
        }
    }
    return { likes, dislikes, isLikedByMe: like };
};
exports.getLikeData = getLikeData;
const getQuestionTypeName = (typeId) => {
    const mappedObj = {
        [models_1.EQuestionType.SINGLE_BEST_ANSWER]: 'QuestionSBA',
        [models_1.EQuestionType.SBA_WITH_MULTIPLE_CHOICES]: 'QuestionSBA',
        [models_1.EQuestionType.QUESTION_ANSWER]: 'QuestionQA',
        [models_1.EQuestionType.MULTIPLE_ANSWERS]: 'QuestionMultiA',
        [models_1.EQuestionType.PRESCRIPTION_ANSWER]: 'QuestionPrescription',
        [models_1.EQuestionType.EXTENDED_MATCHING_ANSWER]: 'QuestionEMQ',
        [models_1.EQuestionType.RANKING_ANSWER]: 'QuestionRanking',
        [models_1.EQuestionType.SELECT_THREE_ANSWER]: 'QuestionSelect3',
        [models_1.EQuestionType.VERBAL_READING_COMPREHENSION]: 'QuestionSBA',
        [models_1.EQuestionType.VERBAL_VERACITY]: 'QuestionSBA',
        [models_1.EQuestionType.QUANTITATIVE_REASONING_SBA]: 'QuestionSBA',
        [models_1.EQuestionType.DECISION_MAKING_SBA]: 'QuestionSBA',
        [models_1.EQuestionType.DECISION_MAKING_YES_NO]: 'QuestionMultiA',
        [models_1.EQuestionType.SJT_SINGLE_CHOICE]: 'QuestionSBA',
        [models_1.EQuestionType.SJT_TWO_ANSWERS]: 'QuestionSelect3',
    };
    return mappedObj[typeId] ?? 'QuestionSBA';
};
exports.getQuestionTypeName = getQuestionTypeName;
const addCommentToDiscussion = (newComment, comments, parentId) => {
    if (parentId) {
        const commentIndex = comments.findIndex(({ id }) => Number(id) === parentId);
        const { replies = [], ...commentRest } = comments[commentIndex];
        return [
            ...comments.slice(0, commentIndex),
            { ...commentRest, replies: [...replies, newComment] },
            ...comments.slice(commentIndex + 1),
        ];
    }
    return [...comments, newComment];
};
const removeCommnetFromDiscussion = (comments, commentId, parentId) => {
    if (parentId) {
        const commentIndex = comments.findIndex(({ id }) => Number(id) === Number(parentId));
        const { replies = [], ...commentRest } = comments[commentIndex];
        return [
            ...comments.slice(0, commentIndex),
            {
                ...commentRest,
                replies: replies.filter(({ id }) => Number(id) !== Number(commentId)),
            },
            ...comments.slice(commentIndex + 1),
        ];
    }
    return comments.filter(({ id }) => Number(id) !== Number(commentId));
};
const updateCommentFromDiscussion = (comments, commentId, update, parentId) => {
    const updatedComments = [...comments];
    if (parentId) {
        const parentIndex = comments.findIndex((comment) => Number(comment.id) === Number(parentId));
        if (parentIndex !== -1) {
            const parentComment = updatedComments[parentIndex];
            parentComment.replies = (parentComment.replies ?? []).map((reply) => Number(reply.id) === Number(commentId)
                ? { ...reply, ...update }
                : reply);
        }
    }
    else {
        const commentIndex = comments.findIndex((comment) => Number(comment.id) === Number(commentId));
        if (commentIndex !== -1) {
            updatedComments[commentIndex] = {
                ...updatedComments[commentIndex],
                ...update,
            };
        }
    }
    return updatedComments;
};
exports.QUESTION_LIKE = (0, client_1.gql) `
  mutation QuestionLike($marksheetId: Int, $questionId: Int!, $like: Int!) {
    restricted {
      questionLike(
        marksheetId: $marksheetId
        questionId: $questionId
        like: $like
      ) {
        id
        likes
        typeId
        dislikes
        isLikedByMe
      }
    }
  }
`;
const optimisticQuestionLike = (input, question) => {
    const { like } = input;
    return {
        restricted: {
            questionLike: {
                ...question,
                ...(0, exports.getLikeData)(like, question),
            },
        },
    };
};
exports.optimisticQuestionLike = optimisticQuestionLike;
exports.QUESTION_COMMENTS = (0, client_1.gql) `
  ${fragments_1.QUESTION_COMMENT_FIELDS}
  mutation QuestionComments(
    $marksheetId: Int
    $questionId: Int!
    $parentId: Int
    $comment: String!
  ) {
    restricted {
      questionComments(
        marksheetId: $marksheetId
        questionId: $questionId
        parentId: $parentId
        comment: $comment
      ) {
        ...QuestionCommentFields
      }
    }
  }
`;
const updateQuestionComments = (typeId) => (cache, result, options) => {
    const { questionComments } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !questionComments) {
        return;
    }
    const { questionId, parentId } = variables;
    try {
        const dataFragment = cache.readFragment({
            id: cache.identify({
                id: questionId,
                __typename: (0, exports.getQuestionTypeName)(typeId),
            }),
            fragment: fragments_1.QUESTION_WITH_COMMENT_FIELDS,
            fragmentName: 'QuestionWithCommentFields',
        });
        if (dataFragment) {
            const { comments = [] } = dataFragment;
            cache.writeFragment({
                id: cache.identify({
                    id: questionId,
                    __typename: (0, exports.getQuestionTypeName)(typeId),
                }),
                data: {
                    ...dataFragment,
                    comments: addCommentToDiscussion(questionComments, comments, parentId),
                },
                fragment: fragments_1.QUESTION_WITH_COMMENT_FIELDS,
                fragmentName: 'QuestionWithCommentFields',
            });
        }
    }
    catch (error) {
        console.error(error);
    }
};
exports.updateQuestionComments = updateQuestionComments;
const optimisticQuestionComment = (id, user, input) => {
    const { parentId, questionId, comment } = input;
    const { displayName, id: userId, accessLevel } = user || {};
    const newComment = {
        createdAt: new Date(),
        id,
        likes: 0,
        questionId,
        dislikes: 0,
        isLikedByMe: models_1.EQuestionLike.NONE,
        user: { displayName, id: userId, accessLevel },
        comment,
        parentId: parentId ? parentId : 0,
        replies: [],
    };
    return {
        restricted: {
            questionComments: {
                __typename: 'QuestionComment',
                ...newComment,
            },
        },
    };
};
exports.optimisticQuestionComment = optimisticQuestionComment;
exports.QUESTION_COMMENT_LIKE = (0, client_1.gql) `
  ${fragments_1.QUESTION_COMMENT_FIELDS}
  mutation QuestionCommentLike(
    $marksheetId: Int
    $questionId: Int!
    $commentId: Int!
    $like: Int!
  ) {
    restricted {
      questionCommentLike(
        marksheetId: $marksheetId
        questionId: $questionId
        commentId: $commentId
        like: $like
      ) {
        ...QuestionCommentFields
      }
    }
  }
`;
const optimisticCommentLike = (comments, input, parentId) => {
    const { commentId, like } = input;
    const topLevelComment = comments.find(({ id }) => Number(id) === Number(parentId || commentId)) ||
        {};
    const comment = parentId && topLevelComment.replies
        ? topLevelComment.replies.find(({ id }) => Number(id) === Number(commentId)) || {}
        : topLevelComment;
    return {
        restricted: {
            questionCommentLike: {
                ...comment,
                replies: parentId ? [] : comment.replies,
                id: Number(comment.id),
                __typename: 'QuestionComment',
                ...(0, exports.getLikeData)(like, comment),
            },
        },
    };
};
exports.optimisticCommentLike = optimisticCommentLike;
exports.QUESTION_COMMENT_REMOVE = (0, client_1.gql) `
  ${fragments_1.QUESTION_COMMENT_FIELDS}
  mutation QuestionCommentRemove(
    $marksheetId: Int
    $questionId: Int!
    $commentId: Int!
  ) {
    restricted {
      questionCommentRemove(
        marksheetId: $marksheetId
        questionId: $questionId
        commentId: $commentId
      ) {
        ...QuestionCommentFields
      }
    }
  }
`;
const updateQuestionCommentsRemove = (typeId) => (cache, result, options) => {
    const { questionCommentRemove } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !questionCommentRemove) {
        return;
    }
    const { questionId, id: commentId, parentId, userId, user, createdAt, } = questionCommentRemove;
    try {
        const dataFragment = cache.readFragment({
            id: cache.identify({
                id: questionId,
                __typename: (0, exports.getQuestionTypeName)(typeId),
            }),
            fragment: fragments_1.QUESTION_WITH_COMMENT_FIELDS,
            fragmentName: 'QuestionWithCommentFields',
        });
        if (dataFragment) {
            const { comments = [] } = dataFragment;
            const createdAtDate = luxon_1.DateTime.fromSeconds(createdAt);
            const diffInHours = luxon_1.DateTime.now().diff(createdAtDate, 'hours').hours;
            let updatedComments = [];
            if (diffInHours >= 24) {
                updatedComments = updateCommentFromDiscussion(comments, commentId, { userId, user }, parentId);
            }
            else {
                updatedComments = removeCommnetFromDiscussion(comments, commentId, parentId);
            }
            cache.writeFragment({
                id: cache.identify({
                    id: questionId,
                    __typename: (0, exports.getQuestionTypeName)(typeId),
                }),
                data: {
                    ...dataFragment,
                    comments: updatedComments,
                },
                fragment: fragments_1.QUESTION_WITH_COMMENT_FIELDS,
                fragmentName: 'QuestionWithCommentFields',
            });
        }
    }
    catch (error) {
        console.error(error);
    }
};
exports.updateQuestionCommentsRemove = updateQuestionCommentsRemove;
const optimisticQuestionCommentRemove = (comments, input, parentId) => {
    const { commentId } = input;
    let comment;
    if (parentId) {
        const parent = comments.find(({ id }) => Number(id) === Number(parentId)) ||
            {};
        comment =
            parent?.replies?.find(({ id }) => Number(id) === Number(commentId)) ||
                {};
    }
    else {
        comment =
            comments.find(({ id }) => Number(id) === Number(commentId)) ||
                {};
    }
    return {
        restricted: {
            questionCommentRemove: {
                __typename: 'QuestionComment',
                ...comment,
                parentId: parentId ? parentId : 0,
                replies: comment.replies ? comment.replies : [],
            },
        },
    };
};
exports.optimisticQuestionCommentRemove = optimisticQuestionCommentRemove;
exports.ADD_QUESTION_HIGHLIGHT = (0, client_1.gql) `
  ${fragments_1.HIGHLIGHT_FIELDS}
  mutation AddQuestionHighlight(
    $input: [AddQuestionHighlightInput!]!
    $marksheetId: Int
  ) {
    restricted {
      addQuestionHighlight(input: $input, marksheetId: $marksheetId) {
        id
        questionId
        userId
        highlights {
          ...HighlightFields
        }
      }
    }
  }
`;
const updateQuestionHighlights = (typeId) => (cache, result, options) => {
    const { addQuestionHighlight } = result?.data?.restricted ?? {};
    const { variables } = options || {};
    if (!variables || !addQuestionHighlight) {
        return;
    }
    try {
        for (const { questionId, highlights } of addQuestionHighlight) {
            cache.writeFragment({
                id: cache.identify({
                    id: questionId,
                    __typename: (0, exports.getQuestionTypeName)(typeId),
                }),
                data: {
                    highlights,
                },
                fragment: fragments_1.QUESTION_WITH_HIGHLIGHT_FIELDS,
            });
        }
    }
    catch (error) {
        console.error(error);
    }
};
exports.updateQuestionHighlights = updateQuestionHighlights;
exports.ADD_QUESTION_LEARNING_POINT = (0, client_1.gql) `
  mutation AddQuestionLearningPoint(
    $input: [AddQuestionLearningPointInput!]!
    $marksheetId: Int
  ) {
    restricted {
      addQuestionLearningPoint(input: $input, marksheetId: $marksheetId) {
        id
        questionId
        userId
        userPoint
      }
    }
  }
`;
const updateQuestionLearningPoint = (typeId) => (cache, result, options) => {
    const { addQuestionLearningPoint } = result?.data?.restricted ?? {};
    const { variables } = options || {};
    if (!variables || !addQuestionLearningPoint) {
        return;
    }
    try {
        for (const { questionId, userPoint } of addQuestionLearningPoint) {
            cache.writeFragment({
                id: cache.identify({
                    id: questionId,
                    __typename: (0, exports.getQuestionTypeName)(typeId),
                }),
                data: {
                    userPoint,
                },
                fragment: fragments_1.QUESTION_WITH_LEARNING_FIELDS,
            });
        }
    }
    catch (error) {
        console.error(error);
    }
};
exports.updateQuestionLearningPoint = updateQuestionLearningPoint;
const getQuestionHighlightOptimisticResponse = (userId, highlights, questionId) => {
    const date = new Date().getTime();
    return {
        restricted: {
            addQuestionHighlight: [
                {
                    questionId,
                    id: date,
                    userId,
                    createdAt: date,
                    updatedAt: date,
                    deletedAt: date,
                    highlights: highlights.map((highlight) => ({
                        __typename: 'HighlightNode',
                        tag: '',
                        color: '',
                        part: '',
                        ...highlight,
                    })),
                    __typename: 'ChapterHighlight',
                },
            ],
        },
    };
};
exports.getQuestionHighlightOptimisticResponse = getQuestionHighlightOptimisticResponse;
